<template>
  <div id="layout">
    <Header />
    <keep-alive :include="['ResourceInfo','Header']">
      <router-view />
    </keep-alive>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'Layout',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0px;
  padding:0px;
  border:none
}
</style>
